"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TectonicStakingPoolStorageV1Factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        name: "_cooldownPeriod",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "_tonic",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "_xTonic",
        outputs: [
            {
                internalType: "contract xTonic",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "tcmPublicAccess",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b50610107806100206000396000f3fe6080604052348015600f57600080fd5b506004361060465760003560e01c80630fab0e7614604b578063109f9b911460735780633dbd138614609c578063e920978f1460ae575b600080fd5b600454605e90600160201b900460ff1681565b60405190151581526020015b60405180910390f35b6001546085906001600160a01b031681565b6040516001600160a01b039091168152602001606a565b6000546085906001600160a01b031681565b60045460bd9063ffffffff1681565b60405163ffffffff9091168152602001606a56fea264697066735822122066998976736632f3f25284f267e34216c53a06f77a4d0a3edb0a754fbe52923764736f6c63430008030033";
class TectonicStakingPoolStorageV1Factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.TectonicStakingPoolStorageV1Factory = TectonicStakingPoolStorageV1Factory;
TectonicStakingPoolStorageV1Factory.bytecode = _bytecode;
TectonicStakingPoolStorageV1Factory.abi = _abi;
//# sourceMappingURL=TectonicStakingPoolStorageV1Factory.js.map